import React, { Fragment, useState, useRef } from "react";
import { Popup } from "semantic-ui-react";

import Api from "../../services/api";
import { getText } from "../../helpers";
import Toastr from "../toastr";
import CreateInspectionModal from "./create_inspection_modal";
import InspectionDetails from "./inspection_details";

const CreateInspectionLink = (props) => {
  let { label = getText("Create Inspection"), planId, workPhase, activity, inspections = [], onCreateInspectionSuccess } = props;
  inspections = inspections.sort((a, b) => {
    return new Date(b.created_at) - new Date(a.created_at);
  });
  workPhase = workPhase && workPhase.trim();
  activity = activity && activity.trim();
  const riskDescription = `${workPhase} / ${activity}`;
  const hasInspection = inspections && inspections.length > 0;

  const defaultState = {
    createInspectionProcessing: false,
    messageShown: false,
    messageHeader: "",
    messageBody: "",
    messageType: "",
    messageClass: "",
  };
  const [state, setState] = useState(defaultState);
  const [inspectionDetailsShown, setInspectionDetailsShown] = useState(false);
  const [createInspectionConfirmationShown, setCreateInspectionModalShown] = useState(false);
  const { createInspectionProcessing, messageShown, messageHeader, messageBody, messageType, messageClass } = state;

  let messageTimer = useRef();

  const onCreateInspectionClick = (evt) => {
    evt.stopPropagation();
    showCreateInspectionModal(evt);
  };

  const createInspection = (create_details) => {
    setState({ ...state, createInspectionProcessing: true });

    const api = new Api();
    api
      .post("/__api/v1/iauditor/inspection", create_details)
      .then((response) => {
        onCreateInspectionSuccess && onCreateInspectionSuccess(response.data);
        showCreateInspectionSuccess(create_details.risk_description);
        hideCreateInspectionModal();
      })
      .catch((err) => {
        if (err.response.data.error === "Inspection will not created because there are no critical controls.") {
          showCreateInspectionInfo(create_details.risk_description);
        } else {
          showCreateInspectionError(create_details.risk_description);
        }
      });
  };

  const confirmCreateInspection = (evt, create_details = {}) => {
    create_details = {
      plan_id: planId,
      risk_description: riskDescription,
      column_name: "activity",
      ...create_details,
    };
    createInspection(create_details);
  };

  const showCreateInspectionModal = (evt) => {
    evt.stopPropagation();
    setCreateInspectionModalShown(true);
  };

  const hideCreateInspectionModal = (evt) => {
    evt && evt.stopPropagation();
    setCreateInspectionModalShown(false);
  };

  const showInspectionDetails = (evt) => {
    evt.stopPropagation();
    setInspectionDetailsShown(true);
  };

  const hideInspectionDetails = (evt) => {
    evt.stopPropagation();
    setInspectionDetailsShown(false);
  };

  const dismissMessage = () => {
    setState({
      ...state,
      messageShown: false,
      messageHeader: "",
      messageBody: "",
      messageType: "",
      messageClass: "",
    });
  };

  const showMessage = (messageState, timeout = 6000) => {
    clearTimeout(messageTimer.current);
    messageTimer.current = setTimeout(() => {
      dismissMessage();
    }, timeout);

    setState(messageState);
  };

  const showCreateInspectionSuccess = (risk_description) => {
    showMessage({
      messageBody: `${getText("The inspection was successfully created in SafetyCulture for Activity")} - '${risk_description}'.`,
      messageShown: true,
      messageType: 'success',
      messageClass: 'create-inspection-success',
      messageHeader: getText('Instruction'),
      createInspectionProcessing: false
    }, 4000)
  }

  const showCreateInspectionError = (risk_description) => {
    showMessage({
      messageBody: `${getText("Something went wrong in instructing SafetyCulture to create inspection for Activity")} - '${risk_description}'.`,
      messageShown: true,
      messageType: "error",
      messageClass: "create-inspection-error",
      messageHeader: getText("Error"),
      createInspectionProcessing: false,
    });
  };

  const showCreateInspectionInfo = (risk_description) => {
    showMessage({
      messageBody: `${getText("There are No critical controls for the Activity")} - '${risk_description}' ${getText(
        "and therefore no inspection was created in SafetyCulture"
      )}.`,
      messageShown: true,
      messageType: "info",
      messageClass: "create-inspection-info",
      messageHeader: getText("Info"),
      createInspectionProcessing: false,
    });
  };

  return (
    <Fragment>
      {createInspectionProcessing ? (
        <a className="create-inspection-button-link processing">
          {getText("Creating Inspection")}..<i className="loading circle notched icon"></i>
        </a>
      ) : (
        <Fragment>
            <Popup
              inline
              trigger={
                <a className="create-inspection-button-link" onClick={onCreateInspectionClick}>
                  {label}
                </a>
              }
              content={getText(
                "This will create a new inspection in SafetyCulture that requires the verification of all the critical controls associated with this activity."
              )}
              className="create-inspection-desc"
            />

          {createInspectionConfirmationShown && (
            <CreateInspectionModal
              planId={planId}
              workPhase={workPhase}
              activity={activity}
              riskDescription={riskDescription}
              inspections={inspections}
              hideCreateInspectionModal={hideCreateInspectionModal}
              confirmCreateInspection={confirmCreateInspection}
            />
          )}
          {hasInspection && (
            <a className="inspection-details" onClick={showInspectionDetails}>
              {getText("Inspection Details")}
            </a>
          )}
          {inspectionDetailsShown && (
            <InspectionDetails
              workPhase={workPhase}
              activity={activity}
              riskDescription={riskDescription}
              inspections={inspections}
              hideInspectionDetails={hideInspectionDetails}
            />
          )}
        </Fragment>
      )}
      {messageShown && (
        <Toastr className={messageClass} messageHeader={messageHeader} messageBody={messageBody} messageType={messageType} dismiss={dismissMessage} />
      )}
    </Fragment>
  );
};

export default CreateInspectionLink;



// WEBPACK FOOTER //
// ./src/components/create_inspection_link/create_inspection_link.js